import { PluginObject } from 'vue'
import { Vue as VueType } from 'vue/types/vue';
import ErrorDialog from '@/plugins/GlobalDialog/components/ErrorDialog.vue';
import SuccessDialog from '@/plugins/GlobalDialog/components/SuccessDialog.vue';
import SuccessDialogModel from '@/plugins/GlobalDialog/models/successDialog.model';
import ErrorDialogModel from '@/plugins/GlobalDialog/models/errorDialog.model';
import InfoDialogModel from '@/plugins/GlobalDialog/models/infoDialog.model'
import InfoDialog from '@/plugins/GlobalDialog/components/InfoDialog.vue'

declare module 'vue/types/vue' {
  interface Vue {
    EventBus: Vue
    $successDialog: SuccessDialogModel
    $errorDialog: ErrorDialogModel
    $infoDialog: InfoDialogModel
  }

  interface VueConstructor {
    $eventBus: Vue
  }
}

const SuccessDialogPlugin: PluginObject<SuccessDialogModel> = {
  install(vue: typeof VueType, options: SuccessDialogModel | undefined): void {
    this.$eventBus = new vue()

    vue.component('success-dialog', SuccessDialog)
    vue.prototype.$successDialog = new SuccessDialogModel()
  },
}

const InfoDialogPlugin: PluginObject<InfoDialogModel> = {
  install(vue: typeof VueType, options: InfoDialogModel | undefined): void {
    this.$eventBus = new vue()

    vue.component('info-dialog', InfoDialog)
    vue.prototype.$infoDialog = new InfoDialogModel()
  },
}

const ErrorDialogPlugin: PluginObject<ErrorDialogModel> = {
  install(vue: typeof VueType, options: ErrorDialogModel | undefined): void {
    this.$eventBus = new vue()

    vue.component('error-dialog', ErrorDialog)
    vue.prototype.$errorDialog = new ErrorDialogModel()
  },
}

export {
  SuccessDialogPlugin,
  ErrorDialogPlugin,
  InfoDialogPlugin,
}
